import React, { useState, useEffect } from "react";
import { TextField, Button, Box, Typography, InputAdornment, Snackbar, Alert, Dialog, DialogContent, DialogTitle } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import CoverLayout from "layouts/newVendor/vendorRegistration/components/CoverLayout";
import { useNavigate } from "react-router-dom";
import "../style.css"
import { ToastContainer, toast } from "react-toastify";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import Select from "react-select"
import { getAllUsers } from "assets/globalAPI/apiGlobal";
import Table from 'react-bootstrap/Table';
import { Pagination } from "react-bootstrap";
import { sendAnmolOTP } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { validateVendor } from "assets/globalAPI/apiGlobal";
import SoftTypography from "components/SoftTypography";
import { validateCust } from "assets/globalAPI/apiGlobal";

const CustomerValidation = () => {
  const toastId = React.useRef(null);
  const navigate= useNavigate();
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName]= useState("")
  const [otpMobile, setOtpMobile] = useState("");
  const [otpEmail, setOtpEmail] = useState("");
  const [otpEnabledMobile, setOtpEnabledMobile] = useState(false);
  const [otpEnabledEmail, setOtpEnabledEmail] = useState(false);
  const [otpVerifiedMobile, setOtpVerifiedMobile] = useState(false);
  const [otpVerifiedEmail, setOtpVerifiedEmail] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [otpSentMobile, setOtpSentMobile] = useState(false);
  const [otpSentEmail, setOtpSentEmail] = useState(false);
  const [custType,setCustType]= useState(""); 
    const [open, setOpen] = useState(false);
    const [users, setUsers] = useState([]);
     const [currentPage, setCurrentPage]= useState(1);
          const [totalPages, setTotalPages]= useState(1);
          const [userSearch,setUserSearch]= useState("");
          const typingTimeoutRef = React.useRef(null);
            const latestSearchRef = React.useRef("");

  const handleGetOtpForMobile = () => {
    if ( mobile.length === 10) {
      setOtpEnabledMobile(true);
      setOtpSentMobile(true);
     
    } else {
      if (!toast.isActive(toastId.current)){
        toastId.current= toast.warning("Please enter a valid 10-digit mobile number",{
          className: "small-toast"
        } );
      };
    }
  };
  const handlePageChange=(p)=>{
    setCurrentPage(p);
  }


  const handleGetOtpForEmail = async() => {
      setIsActive(true);
      if ( userEmail!==""&& userEmail) {
          // if (!toast.isActive(toastId.current)){
          //   toastId.current= toast.success("Please enter a OTP sent to concerned person",{
          //     className: "small-toast"
          //   } );
          // }
          const body={
            usertype: "customer",
            type:custType,
            anmol_name: userName,
            anmoluser: userEmail,
            anmolemail: email,
            anmolmobile: mobile
          }
          try{
            const response= await sendAnmolOTP(body);
            const res= response.data;
            console.log("the result>> ", res)
            if(res.status){
              if (!toast.isActive(toastId.current)){
                toastId.current= toast.success(res.message,{
                  className: "small-toast"
                } );
              }
              console.log("sent response>> ", res)
              setIsActive(false)
              setOtpEnabledEmail(true);
              setOtpSentEmail(true);
            }else{
              if (!toast.isActive(toastId.current)){
                toastId.current= toast.error(res.message,{
                  className: "small-toast"
                } );
              }
              console.log("Why not send>> ", res)
              setIsActive(false);
            }
          }catch(err){
            if (!toast.isActive(toastId.current)){
              toastId.current= toast.error(err.message,{
                className: "small-toast"
              } );
            }
            console.log("Error sending OTP>> ", err)
            setIsActive(false)
          }
          // setOtpEnabledEmail(true);
          // setOtpSentEmail(true);
         
          console.log("body for otp>> ", body)
      } else {
        if (!toast.isActive(toastId.current)){
          toastId.current= toast.warning("Please select concerned person",{
            className: "small-toast"
          } );
        }
      }
    };

    useEffect(()=>{
      fetchAllUsers(currentPage)
    },[currentPage])

    const handleUserChange=(user)=>{
      setUserEmail(user.email);
      setUserName(user.name)
      setOpen(false)
    }

  // const handleVerifyOtpEmail = () => {
  //   if (otpEmail === "123456") { // Mock OTP verification
  //     setOtpVerifiedEmail(true);
  //     alert("OTP Verified Successfully!"); // Mock success message
  //   } else {
  //     alert("Invalid OTP. Please try again.");
  //   }
  // };

  // const handleVerifyOtpMobile = () => {
  //   if (otpMobile === "123456") { // Mock OTP verification
  //     setOtpVerifiedMobile(true);
  //     alert("OTP Verified Successfully!"); // Mock success message
  //   } else {
  //     alert("Invalid OTP. Please try again.");
  //   }
  // };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setUserSearch(value);
    latestSearchRef.current = value;
 
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
 
   
typingTimeoutRef.current = setTimeout(() => {
  fetchAllUsers(); // Inside this function, access latest value from latestSearchRef.current
}, 2000);
}

  const fetchAllUsers=async()=>{
    setIsActive(true)
            const body={
                page: latestSearchRef.current=="" ?currentPage:1,
                search: latestSearchRef.current
            }
            try{
                const response= await getAllUsers(body);
                const res= response.data;
                console.log("response is>> ", res)
                if(res.status){
                  setIsActive(false)
                    console.log("all users fetched>> ", res);
                    setUsers(res.data);
                    setTotalPages(res.totalPages)
                }else{
                  setIsActive(false)
                    console.log("could not fetch users>> ", res);
                   
                    setTotalPages(1);
                    setUsers([])
                }
            }catch(err){
              setIsActive(false)
                console.log("the error is bringing users>> ", err)
               
                
            }
          }

  const handleCaptchaChange = (token) => {
    setCaptchaValue(token);
  };

  useEffect(() => {
    if(custType!=="" && email!=="" && mobile!==""){
      if(mobile.length==10 && email!==""){
        checkCustomer();
      }else{
        return;
      }
    }else{
      return;
    }
  },[custType, email, mobile]);

  const checkCustomer= async()=>{
      setIsActive(true)
      const body={
        usertype: "customer",
        type: custType,
        anmolemail: email,
        anmolmobile: mobile,
      }
  if(mobile.length===10){
  
    try{
      const response= await validateCust(body);
      const res= response.data;
      console.log("Response for checking customer>> ", res);
      if(res.status){
        if (!toast.isActive(toastId.current)){
          toastId.current= toast.success(res.message,{
            className: "small-toast"
          } );
        }

        // localStorage.setItem("isRegistered", true);
        if(res.result){
          setUserEmail(res.result.email);
          setUserName(res.result.name);
          setIsActive(false);
        }
        setIsActive(false)
       
      }else{
        // if (!toast.isActive(toastId.current)){
        //   toastId.current= toast.warning(res.message,{
        //     className: "small-toast"
        //   } );
        // }
        setIsActive(false)
        console.log("Why not validate>> ", res)
      }
    }catch(err){
      console.log("Error checking cust>> ", err);
      if (!toast.isActive(toastId.current)){
        toastId.current= toast.error(err.message,{
          className: "small-toast"
        } );
      }
      setIsActive(false)
    }
  }else {
    if (!toast.isActive(toastId.current)){
      toastId.current= toast.warning("Please enter valid 10-digit mobile number",{
        className: "small-toast"
      } );
    }
  }
      
      
      // if(otpEmail!=="123456"){
      //   if (!toast.isActive(toastId.current)){
      //     toastId.current= toast.warning("Please enter valid OTP sent to concerned person",{
      //       className: "small-toast"
      //     } );
      //   }
      // }
      // else{
      //   localStorage.setItem("contactPersonEmail", email);
      //   localStorage.setItem("contactPersonMobile", mobile)
      //   if (!toast.isActive(toastId.current)){
      //     toastId.current= toast.success("Authentication Sucessful",{
      //       className: "small-toast"
      //     } );
      //   }
      //   const body={
      //     vendorEmail: email,
      //     vendorPhone: mobile,
      //     concernedPerson: userEmail,
      //     otp: "123456"
      //   }
      //   console.log("vendor registered body>> ", body)
      //   setTimeout(()=>{
      //     navigate("/vendor/validation-2")
      //   }, 1000)
      // }
    }

  const registerCustomer= async()=>{
      setIsActive(true)
      const body={
        usertype: "customer",
        type: custType,
        anmol_name: userName,
        anmoluser: userEmail,
        anmolemail: email,
        anmolmobile: mobile,
        anmoluser_otp: otpEmail
      }
  if(mobile.length===10){
  
    try{
      const response= await validateVendor(body);
      const res= response.data;
      console.log("Response for validation>> ", res);
      if(res.status){
        if (!toast.isActive(toastId.current)){
          toastId.current= toast.success(res.message,{
            className: "small-toast"
          } );
        }

        localStorage.setItem("isRegistered", true);
        localStorage.setItem("customer_type",custType);

        setOtpEmail('');
        setOtpEnabledEmail(false);
        setUserEmail('');
        setUserName('');
        setCustType('');
        setEmail('');
        setMobile('');
        setIsActive(false)
       
      }else{
        if (!toast.isActive(toastId.current)){
          toastId.current= toast.warning(res.message,{
            className: "small-toast"
          } );
        }
        setIsActive(false)
        console.log("Why not validate>> ", res)
      }
    }catch(err){
      console.log("Error validating otp>> ", err);
      if (!toast.isActive(toastId.current)){
        toastId.current= toast.error(err.message,{
          className: "small-toast"
        } );
      }
      setIsActive(false)
    }
  }else {
    if (!toast.isActive(toastId.current)){
      toastId.current= toast.warning("Please enter valid 10-digit mobile number",{
        className: "small-toast"
      } );
    }
  }
      
      
      // if(otpEmail!=="123456"){
      //   if (!toast.isActive(toastId.current)){
      //     toastId.current= toast.warning("Please enter valid OTP sent to concerned person",{
      //       className: "small-toast"
      //     } );
      //   }
      // }
      // else{
      //   localStorage.setItem("contactPersonEmail", email);
      //   localStorage.setItem("contactPersonMobile", mobile)
      //   if (!toast.isActive(toastId.current)){
      //     toastId.current= toast.success("Authentication Sucessful",{
      //       className: "small-toast"
      //     } );
      //   }
      //   const body={
      //     vendorEmail: email,
      //     vendorPhone: mobile,
      //     concernedPerson: userEmail,
      //     otp: "123456"
      //   }
      //   console.log("vendor registered body>> ", body)
      //   setTimeout(()=>{
      //     navigate("/vendor/validation-2")
      //   }, 1000)
      // }
    }

  // const registerVendor=()=>{
  //   if(otpEmail!=="123456"){
  //     if (!toast.isActive(toastId.current)){
  //       toastId.current= toast.warning("Please enter valid OTP sent to concerned person",{
  //         className: "small-toast"
  //       } );
  //     }
  //   }else if(mobile.length!==10){
  //     if (!toast.isActive(toastId.current)){
  //       toastId.current= toast.warning("Please enter valid 10-digit mobile number",{
  //         className: "small-toast"
  //       } );
  //     }
  //   }
  //   else{
  //     localStorage.setItem("customerEmail", email);
  //     localStorage.setItem("customerMobile", mobile)
  //     if (!toast.isActive(toastId.current)){
  //       toastId.current= toast.success("Sucessful",{
  //         className: "small-toast"
  //       } );
  //     }
  //     setTimeout(()=>{
  //       navigate("/customer/validation-2")
  //     }, 1000)
  //   }
  // }

  return (
    
<>
<ToastContainer/>
<SimpleBackdrop openLoader={isActive}/>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
        padding: "20px",
      }}
    >

      <Box
        sx={{
            width: "600px",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box sx={{ mb: 2, display:"flex", justifyContent:"center" }}>
        <img 
          src={anmolLogo} 
          alt="Anmol Industries Limited" 
          style={{ width: "60px", height: "auto" }} 
        />
      </Box>
        <Typography variant="h5" fontWeight="bold" align="center" gutterBottom>
          Customer Registration
        </Typography>

<Box display="flex" alignItems="flex-end" gap={2}>
  <Box display="flex" flexDirection="column"  >
 <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
             Customer Type
           </Typography>
<SoftSelect placeholder="Choose Type" name="designation" id="designation"  
                  options={[
                    { value: "Distributor", label: "Distributor" },
                    { value: "Railway Distributor", label: "Railway Distributor" },
                    { value: "Super Stockist", label: "Super Stockist" },
                    { value: "Sub Distributor", label: "Sub Distributor" },
                    { value: "Sitting Sub Distributor", label: "Sitting Sub Distributor" },
                    { value: "SMT Distributor", label: "SMT Distributor" },
                    { value: "Modern Trade/CPC/Ecommerce", label: "Modern Trade/CPC/Ecommerce" },
                  ]} 
                  onChange={(e)=>setCustType(e.value)}
                  />
  </Box>
</Box>
        <Box display="flex" alignItems="flex-end" gap={2}>
        <Box display="flex" flexDirection="column"  >
           <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
             Customer Contact Email
           </Typography>
           <TextField
            className="input-email-vendor"
             fullWidth
             variant="outlined"
             placeholder="Enter your email ID"
             value={email}
             onChange={(e) => setEmail(e.target.value)}
             sx={{ width: "400px", maxWidth: "100%" }}
           />
         </Box>
       
         {/* Button beside the input */}
       </Box>
       <Box mt={1} display="flex" alignItems="flex-end" gap={2}>
       <Box display="flex" flexDirection="column"  >
           <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
             Customer Contact Number
           </Typography>
           <TextField
           type="text"
            className="input-email-vendor"
             fullWidth
             variant="outlined"
             placeholder="Enter Mobile No."
             value={mobile}
             inputProps={{maxLength:10}}
             onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
              setMobile(onlyNumbers);
            }}
            //  onChange={(e)=>setMobile(e.target.value)}
             sx={{ width: "400px", maxWidth: "100%" }}
           />
         </Box>
       
       </Box>
       {/* <Box mt={1} display="flex" alignItems="flex-end" gap={2}>
       <Box display="flex" flexDirection="column"  >
           <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
             State
           </Typography>
           <Select
    className="input-email-vendor"
    options={[
    ]}
    // value={options.find((option) => option.value === userEmail)}
    
    styles={{
      control: (base) => ({
        ...base,
        width: "400px",
        maxWidth: "100%",
        minHeight: "34px",
        fontSize: "12px",
      }),
    }}
  />
         </Box>
       
       </Box> */}
       {/* <Box mt={1} display="flex" alignItems="flex-end" gap={2}>
       <Box display="flex" flexDirection="column"  >
           <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
             District
           </Typography>
           <Select
    className="input-email-vendor"
    options={[
    ]}
    // value={options.find((option) => option.value === userEmail)}
   
    styles={{
      control: (base) => ({
        ...base,
        width: "400px",
        maxWidth: "100%",
        minHeight: "34px",
        fontSize: "12px",
      }),
    }}
  />
         </Box>
       
       </Box> */}
      <Box mt={1} display="flex" alignItems="flex-end" gap={2}>
      <Box display="flex" flexDirection="column">
  <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
    Concerned Person Name
  </Typography>
  {/* <Select
    className="input-email-vendor"
    options={[
      {value: 1001, label: "Subrata Saha-1001"},
      {value: 1002, label: "Roni Modak-1002"}
    ]}
    // value={options.find((option) => option.value === userEmail)}
    onChange={(e)=>setUserEmail(e.value)}
    styles={{
      control: (base) => ({
        ...base,
        width: "400px",
        maxWidth: "100%",
        minHeight: "34px",
        fontSize: "12px",
      }),
    }}
  /> */}
  <TextField
             type="text"
              className="input-email-vendor"
               fullWidth
               variant="outlined"
               placeholder="Select Concerned Person."
               value={userName}
               inputProps={{readOnly: true}}
               onClick= {()=>{
                setOpen(true)
                fetchAllUsers(currentPage)
               } }
               sx={{ width: "400px", maxWidth: "100%", cursor: 'pointer' }}
             />
</Box>
       <Button
           variant="contained"
           color="primary"
           sx={{ color: "ivory", whiteSpace: "nowrap", height: "fit-content", mt: 2 }}
           onClick={handleGetOtpForEmail}
         >
           Get OTP
         </Button>
      </Box>

       {otpEnabledEmail && (
        <>
        <Typography fontSize="17px" fontFamily="serif" fontWeight="medium" sx={{mt:1.5}}>
        Enter OTP (Email)
      </Typography>
      <TextField
        
        variant="outlined"
        placeholder="Enter valid OTP"
        value={otpEmail}
        onChange={(e) => setOtpEmail(e.target.value)}
      />


        </>

       )}


       {/* {otpEnabledMobile && (
        <>
        
        <Typography fontSize="17px" fontFamily="serif" fontWeight="medium" sx={{mt:1.5}} >
        Enter OTP (Mobile)
      </Typography>
      <TextField
        
        variant="outlined"
        placeholder="Enter valid OTP"
        value={otpMobile}
        onChange={(e) => setOtpMobile(e.target.value)}
      />
        </>
       )} */}

        {/* <Typography fontSize="17px" fontFamily="serif" fontWeight="medium" sx={{ mt: 2, mb: 1 }}>
          Enter OTP(Email)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Enter valid OTP"
          value={otpEmail}
          onChange={(e) => setOtpEmail(e.target.value)}
          disabled={!otpEnabledEmail}
        />

{otpEnabledEmail && (
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2, backgroundColor: "#28a745", color:'ivory' }}
            onClick={handleVerifyOtpEmail}
          >
            Verify OTP
          </Button>
        )} */}


        {/* <Typography fontSize="17px" fontFamily="serif" fontWeight="medium" sx={{ mt: 2, mb: 1 }}>
          Enter OTP(Mobile)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Enter valid OTP"
          value={otpMobile}
          onChange={(e) => setOtpMobile(e.target.value)}
          disabled={!otpEnabledMobile}
        />

        {otpEnabledMobile && (
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2, backgroundColor: "#28a745", color:'ivory' }}
            onClick={handleVerifyOtpMobile}
          >
            Verify OTP
          </Button>
        )} */}

        
      {otpEnabledEmail && (

<Box display="flex" flexDirection="column" alignItems="center" sx={{ mt: 2, mb: 1 }}>
  <Typography align="center" fontSize="17px" fontWeight="medium" sx={{ mb: 1 }}>
    Complete Captcha
  </Typography>
  <ReCAPTCHA
    sitekey="6LcqVcwqAAAAAPtKBhaUCVJUEIriLUATiYxwA4Uv"
    onChange={handleCaptchaChange}
  />
</Box>

      )}    

            <Button
              fullWidth
              variant="contained"
              color="success"
              sx={{ mt: 3, backgroundColor: "#28a745", color:'ivory' ,
                '&:hover': {
      backgroundColor: '#28a745', // Ensure the background stays the same on hover
      color: 'ivory', // Ensure the text color stays the same on hover
    }
              }}
              disabled={!captchaValue}
              onClick={registerCustomer}
            >
              Submit
            </Button>
          
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>Select a User</DialogTitle>
        <DialogContent>
        <input
                                    type="text"
                                    placeholder="Search using Name or Code"
                                    value={userSearch}
                                    onChange={(e) => handleSearchChange(e)}
                                    style={{
                                      width: "100%",
                                      padding: "5px",
                                      marginBottom: "10px",
                                      fontSize: "12px",
                                    }}
                                  />
          <>
          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
          <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>EMAIL</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>USER ID</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>
        </tr>
      </thead>
              {/* <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>User ID</TableCell>
                  <TableCell>Plant</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead> */}
               <tbody>
                                                         
                                                             <>
                                                             {users && users.map((user) => (
                                                               <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                                 <td>{user.name}</td>
                                                                 <td>{user.email}</td>
                                                                 <td>{user.userid}</td>
                                                                 <td>
                                                                   <SoftButton variant="contained" size="small" color="error" onClick={() => handleUserChange(user)}>Select</SoftButton>
                                                                 </td>
                                                               </tr>
                                                             ))}
                                                             </>
                                                             {users?.length === 0 ? (
  <SoftTypography variant="caption">No Users Found</SoftTypography>
) : null}
                                                         </tbody>
            </Table>
          </>

          {/* <TablePagination
            component="div"
            count={totalPages * rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
          /> */}
          <Pagination className="mt-3">
                  <Pagination.Prev 
                    disabled={currentPage === 1} 
                    onClick={() => handlePageChange(currentPage - 1)}
                  />
                  {[...Array(totalPages).keys()].map((page) => (
                    <Pagination.Item 
                      key={page + 1} 
                      active={page + 1 === currentPage} 
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next 
                    disabled={currentPage === totalPages} 
                    onClick={() => handlePageChange(currentPage + 1)}
                  />
                </Pagination>
        </DialogContent>
      </Dialog>
    </Box>
</>

  );
};

export default CustomerValidation;
